/**
 * Loads Stripe.js on demand.
 *
 * Stripe sets its own identifiers, so it is only fetched at the point where a
 * payment form is actually shown, rather than on every page view. At that point
 * it is strictly necessary for the payment the visitor asked to make.
 */
let pending = null

export function loadStripe () {
  if (window.Stripe) {
    return Promise.resolve(window.Stripe)
  }

  if (pending) {
    return pending
  }

  pending = new Promise((resolve, reject) => {
    const script = document.createElement('script')

    script.src = 'https://js.stripe.com/v3/'
    script.async = true
    script.onload = () => resolve(window.Stripe)
    script.onerror = () => {
      pending = null
      reject(new Error('Failed to load Stripe.js'))
    }

    document.head.appendChild(script)
  })

  return pending
}
